import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import {
  getGrnInvoice,
  getGrnInvoiceById,
  getParticularPage,
  getNext,
  getPrevious,
  handleSearch,
  getGrnDetailById,
  getAdditionalCostList,
  createGrnInvoice,
} from "./thunk";
import { NepaliDate } from "@zener/nepali-datepicker-react";
import { dateFormater } from "../../../../../../Utils/dateFormater";
import { resetGrnForm } from "../../GRN/Redux/grnSlice";

const initialState = {
  grnInvoices: [],
  edit: false,
  grnInvoice: null,
  count: 0,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingGrnInvoice: false,
  loadingNext: false,
  loadingDetails: false,
  grn: null,
  goodReceiptNotesDetails: null,
  grnMainAdditionalChargeCost: null,
  additionalCosts: null,
  saveAndContinue: false,
  showCreateModal: false,

  formData: {
    branch: null,
    purchaseOrderMain: null,
    partyAccount: null,
    partyInvoiceNo: "",
    voucherDateBs: new NepaliDate(),
    termsOfDeliveryPayment: "",
    lcNumber: "",
    lcDate: new NepaliDate(),
    ppNumber: "",
    ppDate: new NepaliDate(),

    deliveryThrough: "",
    destination: "",
    termsOfDelivery: "",
    voucherNumber: "",
    gateInwardsNo: "",
    gateInwardDate: new NepaliDate(),
    billDate: new NepaliDate(),
    billNo: "",
    bulityDate: new NepaliDate(),
    bulityNo: "",
    jobNo: "",
    refNo: "",
    narration: "",
    discount: "",
    documentsAttach: [],
  },
};

export const grnInvoiceSlice = createSlice({
  name: "grnInvoice",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    setSaveAndContinue: (state, { payload }) => {
      state.saveAndContinue = payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    grnInvoiceDetailsUpdated: (state, action) => {
      state.additionalCosts = action.payload;
    },
    clearPurchaseOrderDetails: (state, action) => {
      state.goodReceiptNotesDetails = null;
      state.grnMainAdditionalChargeCost = null;
    },

    clearGrnInvoiceDetails: (state) => {},
    clearAllGrnInvoice: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingGrnInvoice = false;
      state.grnInvoice = null;
      state.goodReceiptNotesDetails = null;
      state.grnMainAdditionalChargeCost = null;
      state.additionalCosts = null;
      state.saveAndContinue = false;
      state.formData = initialState.formData;
    },
    saveGrnInvoice: (state, action) => {
      state.formData = action.payload;
    },
    resetGrnInvoiceForm: (state, action) => {
      if (action.payload) {
        state.formData = state.purchaseOrder;
      } else {
        state.formData = initialState.formData;
        state.grnInvoice = initialState.grnInvoice;
        state.goodReceiptNotesDetails = initialState.goodReceiptNotesDetails;
        state.grnMainAdditionalChargeCost = initialState.grnMainAdditionalChargeCost;
      }
    },
  },
  extraReducers: (builder) => {
    // for listing of AdditionalChargeCost
    builder.addCase(createGrnInvoice.pending, (state) => {
      state.loadingCreate = true;
    });
    builder.addCase(createGrnInvoice.fulfilled, (state, action) => {
      state.loadingCreate = false;
    });
    builder.addCase(createGrnInvoice.rejected, (state) => {
      state.loadingCreate = false;
    });
    builder.addCase(getAdditionalCostList.pending, (state) => {
      state.additionalCosts = null;
    });
    builder.addCase(getAdditionalCostList.fulfilled, (state, { payload }) => {
      state.additionalCosts = payload.data.map((item) => ({
        ...item,
        unique: uuidv4(),
        vatRate: 13,
      }));
    });
    builder.addCase(getAdditionalCostList.rejected, (state) => {
      state.additionalCosts = null;
    });

    // getGrnInvoiceById
    builder.addCase(getGrnDetailById.pending, (state) => {
      state.loadingDetails = true;
      state.grnMainAdditionalChargeCost = null;
      state.goodReceiptNotesDetails = null;
    });
    builder.addCase(getGrnDetailById.fulfilled, (state, action) => {
      const sam = action.payload.data?.goodReceiptNotesDetails?.reduce((acc, pos) => {
        return Number(pos.actualQuantity) + acc;
      }, 0);

      state.loadingDetails = false;
      state.grn = action.payload.data;
      state.goodReceiptNotesDetails = action.payload.data?.goodReceiptNotesDetails.map((value) => {
        return { ...value, unique: uuidv4() };
      });
      state.grnMainAdditionalChargeCost = action.payload.data?.grnMainAdditionalChargeCost.map((value) => {
        return { ...value, unique: uuidv4() };
      });
      state.additionalCosts = state.additionalCosts.map((value) => {
        return {
          ...value,
          // amount: value.additionalCharge.canEdit ? value.additionalCharge.rate * sam : value.additionalCharge.amount,
          amount: value.rate * sam,
        };
      });
    });
    builder.addCase(getGrnDetailById.rejected, (state) => {
      state.false = false;
      state.grnMainAdditionalChargeCost = null;
      state.goodReceiptNotesDetails = null;
    });
    builder.addCase(getGrnInvoiceById.pending, (state) => {
      state.loading = true;
      state.grnInvoice = null;
    });
    builder.addCase(getGrnInvoiceById.fulfilled, (state, action) => {
      state.edit = true;
      state.loading = false;
      state.grnInvoice = action.payload.data;
    });
    builder.addCase(getGrnInvoiceById.rejected, (state) => {
      state.edit = false;
      state.loading = false;
      state.grnInvoice = null;
    });
    builder.addMatcher(
      isAnyOf(
        getGrnInvoice.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingGrnInvoice = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getGrnInvoice.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingGrnInvoice = false;
        state.grnInvoices = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getGrnInvoice.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingGrnInvoice = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  setSaveAndContinue,
  goToPage,
  grnInvoiceDetailsUpdated,
  clearPurchaseOrderDetails,
  clearGrnInvoiceDetails,
  clearAllGrnInvoice,
  saveGrnInvoice,
  resetGrnInvoiceForm,
} = grnInvoiceSlice.actions;

export default grnInvoiceSlice.reducer;
